const DOLLAR_SYMBOL = '&#36;';
const BARBADOS_DOLLAR_SYMBOL = 'B&#36;SD';
const KROON_SYMBOL = '&#107;&#114;';
const RIAL_SYMBOL = '&#65020;';
const GUILDER_SYMBOL = '&#402;';
const POUND_SYMBOL = '&#163;';
const RUPEE_SYMBOL = '&#8360;';
const BELARUSIAN_RUBLE_SYMBOL = '&#112;&#46;';
const TENGE_SYMBOL = '&#1083;&#1074;';
const KOREAN_WON_SYMBOL = '&#8361;';
const YEN_SYMBOL = '&#165;';
const PESO_SYMBOL = '&#8369;';

export enum CurrencySymbol {
    EUR = '&#8364;',
    USD = DOLLAR_SYMBOL,
    CAD = DOLLAR_SYMBOL,
    AED = 'د.إ',
    AFN = '&#1547;',
    ALL = '&#76;&#101;&#107;',
    AMD = '֏',
    ANG = GUILDER_SYMBOL,
    ARS = DOLLAR_SYMBOL,
    AUD = DOLLAR_SYMBOL,
    AWG = GUILDER_SYMBOL,
    AZN = '&#1084;&#1072;&#1085;',
    BAM = '&#75;&#77;',
    BBD = BARBADOS_DOLLAR_SYMBOL,
    BDT = '৳',
    BGN = '&#1083;&#1074;',
    BHD = '.د.ب',
    BIF = 'FBu',
    BMD = DOLLAR_SYMBOL,
    BND = DOLLAR_SYMBOL,
    BOB = '&#36;&#98;',
    BRL = '&#82;&#36;',
    BSD = BARBADOS_DOLLAR_SYMBOL,
    BWP = '&#80;',
    BYR = BELARUSIAN_RUBLE_SYMBOL,
    BYN = BELARUSIAN_RUBLE_SYMBOL,
    BZD = '&#66;&#90;&#36;',
    CDF = 'FC',
    CHF = '&#67;&#72;&#70;',
    CLP = DOLLAR_SYMBOL,
    CNY = YEN_SYMBOL,
    COP = DOLLAR_SYMBOL,
    CRC = '&#8353;',
    CUP = PESO_SYMBOL,
    CVE = '$',
    CZK = '&#75;&#269;',
    DJF = 'Fdj',
    DKK = KROON_SYMBOL,
    DOP = '&#82;&#68;&#36;',
    DZD = 'دج',
    EEK = KROON_SYMBOL,
    EGP = POUND_SYMBOL,
    ERN = 'Nfk',
    ETB = 'Br',
    FJD = DOLLAR_SYMBOL,
    FKP = POUND_SYMBOL,
    GBP = POUND_SYMBOL,
    GEL = '₾',
    GGP = POUND_SYMBOL,
    GHC = '&#162;',
    GHS = 'GH₵',
    GIP = POUND_SYMBOL,
    GNF = 'FG',
    GTQ = '&#81;',
    GYD = DOLLAR_SYMBOL,
    HKD = DOLLAR_SYMBOL,
    HNL = '&#76;',
    HRK = '&#107;&#110;',
    HUF = '&#70;&#116;',
    IDR = '&#82;&#112;',
    ILS = '&#8362;',
    IMP = POUND_SYMBOL,
    INR = '₹',
    IQD = 'ع.د',
    IRR = RIAL_SYMBOL,
    ISK = KROON_SYMBOL,
    JEP = POUND_SYMBOL,
    JMD = '&#74;&#36;',
    JOD = 'JD',
    JPY = YEN_SYMBOL,
    KES = 'KEKShS',
    KGS = TENGE_SYMBOL,
    KHR = '&#6107;',
    KMF = 'CF',
    KPW = KOREAN_WON_SYMBOL,
    KRW = KOREAN_WON_SYMBOL,
    KWD = 'KD',
    KYD = DOLLAR_SYMBOL,
    KZT = TENGE_SYMBOL,
    LAK = '&#8365;',
    LBP = POUND_SYMBOL,
    LKR = RUPEE_SYMBOL,
    LRD = DOLLAR_SYMBOL,
    LTL = '&#76;&#116;',
    LVL = '&#76;&#115;',
    LYD = 'LD',
    MAD = 'MAD',
    MDL = 'lei',
    MGA = 'Ar',
    MKD = '&#1076;&#1077;&#1085;',
    MMK = 'K',
    MNT = '&#8366;',
    MOP = 'MOP$',
    MUR = RUPEE_SYMBOL,
    MXN = DOLLAR_SYMBOL,
    MYR = '&#82;&#77;',
    MZN = '&#77;&#84;',
    NAD = DOLLAR_SYMBOL,
    NGN = '&#8358;',
    NIO = '&#67;&#36;',
    NOK = KROON_SYMBOL,
    NPR = RUPEE_SYMBOL,
    NZD = DOLLAR_SYMBOL,
    OMR = RIAL_SYMBOL,
    PAB = '&#66;&#47;&#46;',
    PEN = '&#83;&#47;&#46;',
    PHP = PESO_SYMBOL,
    PKR = RUPEE_SYMBOL,
    PLN = '&#122;&#322;',
    PYG = '&#71;&#115;',
    QAR = RIAL_SYMBOL,
    RON = '&#108;&#101;&#105;',
    RSD = '&#1044;&#1080;&#1085;&#46;',
    RUB = '&#1088;&#1091;&#1073;',
    RWF = 'R₣',
    SAR = RIAL_SYMBOL,
    SBD = DOLLAR_SYMBOL,
    SCR = RUPEE_SYMBOL,
    SDG = 'ج.س.',
    SEK = KROON_SYMBOL,
    SGD = DOLLAR_SYMBOL,
    SHP = POUND_SYMBOL,
    SOS = '&#83;',
    SRD = DOLLAR_SYMBOL,
    SVC = DOLLAR_SYMBOL,
    SYP = POUND_SYMBOL,
    THB = '&#3647;',
    TND = 'د.ت',
    TOP = 'T$',
    TRY = '&#8356;',
    TTD = '&#84;&#84;&#36;',
    TVD = DOLLAR_SYMBOL,
    TWD = '&#78;&#84;&#36;',
    TZS = 'TSh',
    UAH = '&#8372;',
    UGX = 'USh',
    UYU = '&#36;&#85;',
    UZS = TENGE_SYMBOL,
    VEF = '&#66;&#115;',
    VND = '&#8363;',
    XAF = 'FCFA',
    XCD = DOLLAR_SYMBOL,
    XOF = 'CFA',
    YER = RIAL_SYMBOL,
    ZAR = '&#82;',
    ZMK = 'ZK',
    ZWL = '&#90;&#36;'
}
